import { CONSTANTS } from 'config/constants';
import moment from 'moment';
import { currentOrgVar } from 'apollo/reactive-variables/organization';
const { HOLIDAYS } = CONSTANTS;

export const getDeliveryAdvanceWorkingDate = (clinicDeliveryDate: Date, deliveryDaysAdvance: number): Date => {
    const lab = currentOrgVar();
    const holidays = [...lab.holidayDays, ...(lab.unavailableLabDates || []), ...HOLIDAYS];
    let day,
        holidayIndex,
        advanceDeliveryDate = moment(clinicDeliveryDate).startOf('day');
    do {
        advanceDeliveryDate = moment(advanceDeliveryDate).subtract(1, 'days');
        day = advanceDeliveryDate.toDate().getDay();
        const advanceDeliveryDateMilliseconds = advanceDeliveryDate.toDate().setHours(0, 0, 0, 0);
        holidayIndex = holidays.indexOf(advanceDeliveryDateMilliseconds);
        if (!(day === 0 || day === 6 || holidayIndex > -1)) {
            deliveryDaysAdvance = deliveryDaysAdvance - 1;
        }
    } while (deliveryDaysAdvance > 0);
    const currentDateMillSecond = new Date().setHours(12, 0, 0, 0);
    const advanceDeliveryDateMillSecond = advanceDeliveryDate.toDate().setHours(12, 0, 0, 0);
    //INFO: If the advance date is earlier than the current date, we send the current date.
    if (advanceDeliveryDateMillSecond < currentDateMillSecond) {
        return new Date(currentDateMillSecond);
    }
    return advanceDeliveryDate.add(12, 'hours').toDate();
};

export const WorkingDayBeforeCounter = (clinicDeliveryDate: Date, selectedDate: Date): number => {
    const lab = currentOrgVar();
    const holidays = [...lab.holidayDays, ...(lab.unavailableLabDates || []), ...HOLIDAYS];
    const tempClinicDeliveryDate = moment(moment(clinicDeliveryDate).toDate().setHours(12, 0, 0, 0));
    let day,
        holidayIndex,
        selectedDeliveryDate = moment(selectedDate),
        selectedDeliveryDateMilliseconds,
        clinicDeliveryDateMilliseconds,
        count = 0;
    do {
        selectedDeliveryDate = moment(selectedDeliveryDate).add(1, 'days');
        day = selectedDeliveryDate.toDate().getDay();
        selectedDeliveryDateMilliseconds = selectedDeliveryDate.toDate().setHours(12, 0, 0, 0);
        clinicDeliveryDateMilliseconds = tempClinicDeliveryDate.toDate().setHours(12, 0, 0, 0);
        holidayIndex = holidays.indexOf(selectedDeliveryDateMilliseconds);
        if (!(day === 0 || day === 6 || holidayIndex > -1) && selectedDeliveryDate <= tempClinicDeliveryDate) {
            count += 1;
        }
    } while (
        clinicDeliveryDateMilliseconds !== selectedDeliveryDateMilliseconds &&
        selectedDeliveryDate <= tempClinicDeliveryDate
    );
    return count;
};
